// Contact Component
// Contact form for work opportunities and inquiries

import React from 'react';
import './Contact.css';
import ContactForm from './ContactForm';
import { getContactContent } from '../utils/contentLoader';

function Contact() {
  return (
    <section id="contact" className="contact">
      <div className="section-container">
        <div className="contact-content">
          {/* Main message and form side by side */}
          <div className="contact-main-wrapper">
            <div className="contact-message">
              {/* Section title and subtitle moved to left column */}
              <h2 className="section-title">{getContactContent().title || "Get in touch"}</h2>
              <div className="section-divider"></div>
              <p className="section-subtitle">
                {getContactContent().subtitle || "Always looking to discuss new projects, partnerships, or opportunities"}
              </p>

              <h3 className="contact-heading">
                {getContactContent().heading || "Building the Future of Web3 Together"}
              </h3>
              {getContactContent().paragraphs?.map((paragraph, index) => (
                <p key={index} className="contact-text">
                  {paragraph}
                </p>
              ))}
            </div>

            {/* Contact Form for Work Opportunities */}
            <div className="contact-form-container">
              <ContactForm />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;

